import { Injectable } from '@angular/core';
import { Subject, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IApiResp } from '../interfaces/api-resp';
import { HttpClient } from '@angular/common/http';
import { NotificacionesService } from './notificaciones.service';
import { UsuarioService } from './datos/usuario.service';
import { IStock } from '../interfaces/stock';
import { IPreparaciones } from '../interfaces/preparaciones';

@Injectable({
  providedIn: 'root'
})
export class ModalRecogidaService {
  apiURL: string = environment.apiURL;

  private _ocultarModal: boolean = true;
  private _preparacion: any;

  cerrarModalSubject: Subject<void> = new Subject<void>();
  preparacionSubject: Subject<IPreparaciones> = new Subject<IPreparaciones>();

  constructor(
    private http: HttpClient,
    private usuarioSrv: UsuarioService,
    private notificacionesSrv: NotificacionesService
  ) { }


  get preparacion(): any {
    return this._preparacion;
  }

  set preparacion(value: any) {
    this._preparacion = value;
    this.preparacionSubject.next(value);
  }

  get ocultarModal() {
    return this._ocultarModal;
  }


  regularizaPrep(id: any, form: any) {
    const path = `${this.apiURL}/preparaciones/regularizaPrep/${id}`;

    console.log('__SERVICIO regularizaPrep() form', form);
    console.log('__SERVICIO regularizaPrep() path', path);

    return this.http.post<IApiResp>(path, form)
      .pipe(
        catchError(error => {
          this.errorAuth();
          return throwError(() => new Error(error));
        })
      )
  }




  abrirModal() {
    this._ocultarModal = false;
  }

  cerrarModal() {
    this._ocultarModal = true;
    this.cerrarModalSubject.next();
  }

  ///// AUX ////

  errorAuth() {
    this.usuarioSrv.logOut();
    console.log('error', environment.apiErrorAuth);
    // this.notificacionesSrv.aviso('error', environment.apiErrorAuth);
  }

}
